export default {
  contentTitlePlaceholder: {
    id: 'STORY-HEADLINE-DISPLAY_CONTENT_TITLE_PLACEHOLDER',
    defaultMessage: 'Untitled Story (Click to Edit)',
    description:
      'Campaigns > Story Kit > Story Edit Page: placeholder for story content title',
  },
};
